import React from 'react'
import { IoClose } from "react-icons/io5";

const ModalSmall = ({ isOpen, onClose, onConfirm, children }) => {
  return (
    <>
      <div
        className={`fixed flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ${isOpen ? "inset-0 opacity-100 z-999999" : "opacity-0"
          }`}
      >
        <div
          className={`bg-white rounded-xl border border-orange-100 shadow-[0_8px_32px_rgba(0,0,0,0.12)] w-96 p-5 transform transition-transform duration-300 ${isOpen ? "scale-100" : "scale-90"
            }`}
        >
          {children}

          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={onConfirm}
              className="rounded-lg text-sm px-4 py-2 font-semibold uppercase tracking-wide text-white bg-orange-500 shadow-sm shadow-orange-200 hover:bg-orange-600 transition-colors duration-200"
            >
              Confirm
            </button>
            <button
              onClick={onClose}
              className="rounded-lg text-sm px-4 py-2 font-semibold uppercase tracking-wide text-gray-600 bg-orange-50/70 border border-orange-100 hover:bg-orange-100 hover:text-gray-900 transition-colors duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

const ModalLarge = ({ isOpen, title, onClose, modalWidth = true, children }) => {
  return (
    <>
      <div
        className={`fixed flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ${isOpen ? "inset-0 opacity-100 z-999999" : "opacity-0"
          }`}
      >
        <div
          className={`bg-white rounded-xl border border-orange-100 shadow-[0_8px_32px_rgba(0,0,0,0.12)] ${modalWidth ? "w-full md:max-w-2xl" : "w-full md:max-w-md"} transform transition-transform duration-300 ${isOpen ? "scale-100" : "scale-90"
            }`}
        >
          <div
            className="text-gray-900 text-lg font-semibold p-4 rounded-t-xl flex justify-between items-center border-b border-orange-100"
            style={{
              background:
                "radial-gradient(120% 60% at 100% 0%, rgba(249,115,22,0.14) 0%, rgba(249,115,22,0) 55%), linear-gradient(180deg, #FFF9F2 0%, #FFFFFF 100%)",
            }}
          >
            <span>{title}</span>
            <button
              type='button'
              onClick={onClose}
              className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-orange-100 hover:text-orange-500 transition-colors duration-200"
            >
              <IoClose size={20} />
            </button>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export {
  ModalSmall,
  ModalLarge
};